import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    points: [],
    filteredPoints: [],
    selectedPoint: null,
    selectedDistrict: null,
    selectedRegion: null,
    selectedWasteGroups: [],
    filters: {
        federalDistrict: "all",
        region: "all",
        group: "all",
        wasteType: "all",
    },
    co2Data: {
        districts: {},
        regions: {},
    },
    isLegendVisible: false,
    showGradientColoring: false,
    showDensityMap: false,
    selectedYear: "2030",
};

const pointsSlice = createSlice({
    name: "points",
    initialState,
    reducers: {
        setPoints: (state, action) => {
            state.points = action.payload;
            state.filteredPoints = action.payload;
        },
        setLegendVisibility: (state, action) => {
            state.isLegendVisible = action.payload;
        },
        setSelectedPoint: (state, action) => {
            state.selectedPoint = action.payload;
            if (action.payload) {
                // state.selectedRegion = null;
                state.selectedDistrict = null;
            }
        },
        updatePointDetail: (state, action) => {
            const detail = action.payload;

            const patch = (point) =>
                point && point.id === detail.id ? { ...point, ...detail } : point;

            state.points = state.points.map(patch);
            state.filteredPoints = state.filteredPoints.map(patch);
            if (state.selectedPoint?.id === detail.id) {
                state.selectedPoint = { ...state.selectedPoint, ...detail };
            }
        },
        setSelectedDistrict: (state, action) => {
            // console.log('Reducer: setting district', {
            //     current: state.selectedDistrict,
            //     new: action.payload
            // });
            state.selectedDistrict = action.payload;
            state.selectedRegion = null;
        },
        setSelectedRegion: (state, action) => {
            state.selectedRegion = action.payload;
        },
        setFilter: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };

            if (action.payload.region && !action.payload.fromBottomPanel) {
                state.selectedRegion = null;
                state.selectedDistrict = null;
            }

            state.filteredPoints = state.points.filter((point) => {
                if (
                    state.filters.region !== "all" &&
                    point.region !== state.filters.region
                )
                    return false;
                if (
                    state.filters.group !== "all" &&
                    point.group !== state.filters.group
                )
                    return false;
                if (
                    state.filters.federalDistrict !== "all" &&
                    point.federalDistrict !== state.filters.federalDistrict
                )
                    return false;
                if (
                    state.filters.wasteType !== "all" &&
                    point.wasteType !== state.filters.wasteType
                )
                    return false;
                return true;
            });
        },
        setSelectedWasteGroups: (state, action) => {
            state.selectedWasteGroups = action.payload;

            state.filters = {
                ...state.filters,
                group: action.payload.length > 0 ? action.payload[0] : "all",
            };

            // console.log('Redux: groups after update:', {
            //     selectedWasteGroups: state.selectedWasteGroups,
            //     filterGroup: state.filters.group
            // });
        },
        setCo2Data: (state, action) => {
            state.co2Data = action.payload;
        },
        toggleGradientColoring: (state) => {
            state.showGradientColoring = !state.showGradientColoring;
        },
        toggleDensityMap: (state) => {
            state.showDensityMap = !state.showDensityMap;
        },
        setSelectedYear: (state, action) => {
            // console.log("Setting year:", action.payload);
            state.selectedYear = action.payload;
        },
    },
});

export const {
    setPoints,
    setSelectedPoint,
    updatePointDetail,
    setSelectedDistrict,
    setSelectedRegion,
    setFilter,
    setSelectedWasteGroups,
    setLegendVisibility,
    setCo2Data,
    toggleGradientColoring,
    toggleDensityMap,
    setSelectedYear,
} = pointsSlice.actions;

export default pointsSlice.reducer;
